import {
  ScheduledNotificationsActionType,
  ScheduledNotificationsActionTypes,
  ScheduledNotificationsState,
} from './types'

const initialState: ScheduledNotificationsState = {
  all: [],
  errorMsg: '',
  loading: false,
}

export function ScheduledNotificationsReducer(
  state = initialState,
  action: ScheduledNotificationsActionType,
): ScheduledNotificationsState {
  switch (action.type) {
    case ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_REQUEST:
    case ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_REQUEST:
    case ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_REQUEST:
    case ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_REQUEST:
      return { ...state, loading: true, errorMsg: '' }

    case ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_SUCCESS:
      return { ...state, all: action.response, loading: false }

    case ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_SUCCESS:
    case ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_SUCCESS:
    case ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_SUCCESS:
      return { ...state, loading: false }

    case ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_FAILURE:
    case ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_FAILURE:
    case ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_FAILURE:
    case ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_FAILURE:
      return { ...state, errorMsg: action.errorMsg, loading: false }

    default:
      return state
  }
}
